<template>
  <div
      :class="`formulate-input-element formulate-input-element--linked-form`"
      :data-type="context.type"
  >

    <v-dialog persistent v-model="modal" max-width="950" scrollable :fullscreen="$vuetify.breakpoint.mobile">
      <v-card>
        <v-card-title>
          {{ formName }}
          <v-btn outlined color="secondary" class="ml-3" small @click="closeModal">Sluiten <v-icon dense right>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pt-4 text--primary background-color">

          <div class="pt-6 px-md-8 px-4" v-if="loadingForm">
            <v-container fluid>
              <v-row>
                <v-col class="pa-0">
                  <v-skeleton-loader type="text@2, sentences, text@3, image, text@3"></v-skeleton-loader>
                </v-col>
              </v-row>
            </v-container>
          </div>

          <form-fill-core v-if="!loadingForm" @closeModal="closeModal" @savingComplete="onSavingComplete" :form="linkedForm" :form_in_modal="true" />

        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Success dialog when registration is completed -->
    <v-dialog v-model="savingComplete" max-width="400" scrollable @click:outside="saveCompleteClose">
      <v-card>
        <v-card-text class="pt-4 text-center">
          <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>
          <p class="mt-5">Uw registratie is verstuurd.</p>

          <v-btn class="mx-1 my-2" depressed color="primary" v-on:click="saveCompleteClose">
            Gereed
          </v-btn>
        </v-card-text>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>

    <template>
      <v-btn
          :disabled="isAdminMode || disabled"
          color="primary"
          outlined
          @click="openModal"
          class="mt-2"
      >
        {{ registrationLabel }} toevoegen
      </v-btn>
    </template>

  </div>
</template>

<script>
import eformHelpers from "@/mixins/eformHelpers";
import FormFillCore from "@/views/forms/FormFillCore.vue";
import axios from "axios";

export default {
  name: "LinkedForm",
  components: {
    FormFillCore,
  },
  mixins: [
    eformHelpers
  ],
  props: {
    isAdminMode: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
    context: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      modal: false,
      linkedForm: null,
      loadingForm: true,
      savingComplete: false,
    };
  },
  computed: {
    linkedFormId: function() {
      return this.context.attributes.formId;
    },
    registrationLabel: function() {
      return this.context.attributes.registrationLabel ? this.context.attributes.registrationLabel : 'registratie';
    },
    formName() {
      if (this.linkedForm) {
        return this.linkedForm.form_name ? this.linkedForm.form_name : ''
      }
      else {
        return 'Laden..'
      }
    },
  },
  methods: {
    openModal() {
      this.modal = true
      this.loadLinkedForm()
    },
    closeModal() {
      this.modal = false
    },
    onSavingComplete() {
      this.savingComplete = true;
    },
    saveCompleteClose() {
      this.savingComplete = false
      this.closeModal()
    },
    async loadLinkedForm() {
      this.loadingForm = true
      // Fetch results form the API
      await axios
          .get('api/form/' + this.linkedFormId)
          .then(response => {
            this.linkedForm = response.data
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => this.loadingForm = false)
    },
  }
}
</script>

<style lang="scss" scoped>

</style>